<div class="container">

  <app-header-dialog [iconName]="'post_add'">
    Documento
  </app-header-dialog>

  <div class='content'>

    <mat-card>
      <div class="'owner-display">
        <div class="owner-item">
          {{data.member_name}}
        </div>
        <div class="owner-item">
          {{data.product_name}}
        </div>
        <!--
        <div class="owner-item">
          {{data.pending}} - {{data.sent}} - {{data.approved}}
        </div>
        -->
      </div>
    </mat-card>

    <mat-card style='margin-top:10px;'>

      <div class='upload-panel'>

        <input #file type="file" style='display:none;' (change)="previewDoc($event)" />

        <button mat-raised-button (click)='file.click()'>
          <mat-icon class='icon-add'>image_search</mat-icon>
        </button>

        <div class="file-selected">
          <span *ngIf="selectedFile">
            {{selectedFile.name}}
          </span>
        </div>

        <button mat-raised-button (click)='addDocument()' *ngIf="selectedFile">
          <mat-icon class='icon-add'>add_circle_outline</mat-icon>
        </button>

      </div>


    </mat-card>

    <mat-card style='margin-top:10px;'>

      <div class='allfiles' *ngFor="let item of allFiles">
        <div class="file-name">
          {{item.file.name}}
        </div>

        <div *ngIf="item.isProofOfVaccine" class="check-box">
          vacina
        </div>
        <div *ngIf="!item.isProofOfVaccine" class="check-box">
          doc
        </div>

        <div class="delete-box" (click)='removeDocument(item.id)'>
          <mat-icon class='icon-delete'>delete_outline</mat-icon>
        </div>

      </div>

    </mat-card>

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

    <div [ngClass]="{hidden: !spinner}">
      <mat-spinner diameter="30"></mat-spinner>
    </div>

    <button mat-raised-button (click)='updateAllData()'>
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>